import { IMember } from "models/members"

export interface Power {
  name: string
  description: string
  avatar: string
}
export interface Player {
  id: string
  name: string
  avatar: string
  hp: number
  level?: number
  points: number
  powers: Power[]
  objectives: {
    title: string
    description: string
  }[]
}
export interface GameState {
  rounds?: Round[]
  players?: Player[]
  currentRound?: number
  error?: boolean
  ended?: boolean
  generatingRound?: boolean
}

export interface RoundResult {
  player_name: string
  removed_hp?: number
  added_points?: number
  summary: string
  // players: {
  //   player_name: string
  //   removed_hp: number
  //   added_points: number
  //   summary: string
  // }[]
  // game_ended: boolean
}
export interface Round {
  id: string
  image_url?: string
  description: string
  actions: RpgAction[]
  result: RoundResult[]
  tts_url?: string
  roundSummary: string
}

export interface RpgAction {
  description: string
  playerId: string
  name: string
  diceResult: number
  dices: number[]
  id: string
  createdAt: string
}

// ███████╗██╗  ██╗████████╗███████╗███╗   ██╗██████╗ ███████╗██████╗
// ██╔════╝╚██╗██╔╝╚══██╔══╝██╔════╝████╗  ██║██╔══██╗██╔════╝██╔══██╗
// █████╗   ╚███╔╝    ██║   █████╗  ██╔██╗ ██║██║  ██║█████╗  ██║  ██║
// ██╔══╝   ██╔██╗    ██║   ██╔══╝  ██║╚██╗██║██║  ██║██╔══╝  ██║  ██║
// ███████╗██╔╝ ██╗   ██║   ███████╗██║ ╚████║██████╔╝███████╗██████╔╝
// ╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝╚═╝  ╚═══╝╚═════╝ ╚══════╝╚═════╝
//
export interface PlayerExtended extends Player {
  member?: IMember
}
export interface GameStateExtended extends GameState {
  players?: PlayerExtended[]
}

export enum RpgEventType {
  GameStateUpdated = "game-state-updated",
  RoundUpdated = "round-updated",
  GeneratingRound = "generating-round",
}
